import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IEmployeeStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<IEmployeeStatsResponse>,
  IPathBaseParam,
  object
>("stores.employeeStats");

export const employeeStats = {
  ...getApis,
};
